import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './FAQ.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState([]);

  const faqCategories = [
    {
      category: 'Orders & Shipping',
      questions: [
        {
          q: 'How long does shipping take?',
          a: 'Standard shipping typically takes 5-7 business days within the US. Express shipping (2-3 business days) and overnight (1 business day) options are available at checkout. International shipping times vary by destination, usually 7-14 business days.'
        },
        {
          q: 'Do you ship internationally?',
          a: 'Yes, we ship to over 50 countries worldwide. Shipping costs and delivery times will be calculated at checkout based on your location. Please note that international orders may be subject to import duties and taxes.'
        },
        {
          q: 'How can I track my order?',
          a: 'Once your order ships, you will receive a confirmation email with a tracking number. You can also track your order by visiting our Track Order page and entering your order number and email address.'
        },
        {
          q: 'Can I change or cancel my order?',
          a: 'Orders can be modified or cancelled within 2 hours of placing them. Please contact our customer service team immediately if you need to make changes to your order.'
        }
      ]
    },
    {
      category: 'Returns & Exchanges',
      questions: [
        {
          q: 'What is your return policy?',
          a: 'We offer a 30-day return policy for unworn, unwashed items with original tags attached. Returns must be initiated within 30 days of delivery. Please visit our Returns page for complete instructions.'
        },
        {
          q: 'How do I return an item?',
          a: 'To initiate a return, log into your account or contact our customer service team. You will receive a return label via email. Pack the items securely and drop off the package at any authorized shipping location.'
        },
        {
          q: 'When will I receive my refund?',
          a: 'Once we receive your return, please allow 3-5 business days for inspection and processing. Refunds will be issued to your original payment method and may take an additional 5-10 business days to appear, depending on your bank.'
        },
        {
          q: 'Can I exchange an item?',
          a: 'Yes, exchanges are processed as a return and new purchase. For the fastest service, please return your item and place a new order for the desired item.'
        }
      ]
    },
    {
      category: 'Product & Sizing',
      questions: [
        {
          q: 'How do I find my size?',
          a: 'Please refer to our Size Guide page for detailed measurements and fit information for each brand. If you\'re between sizes, we generally recommend sizing up for a more comfortable fit.'
        },
        {
          q: 'Are your products authentic?',
          a: 'Yes, 100%. We work directly with authorized designers and brands to ensure all products are authentic and of the highest quality.'
        },
        {
          q: 'How should I care for my items?',
          a: 'Each item includes care instructions on its product page and on the garment tag. Generally, we recommend dry cleaning for delicate items and following the specific care instructions provided.'
        }
      ]
    },
    {
      category: 'Account & Payment',
      questions: [
        {
          q: 'What payment methods do you accept?',
          a: 'We accept all major credit cards (Visa, Mastercard, American Express), PayPal, Apple Pay, and Google Pay. All transactions are secure and encrypted.'
        },
        {
          q: 'Is my payment information secure?',
          a: 'Yes, we use industry-standard SSL encryption to protect your payment information. We never store your full credit card details on our servers.'
        },
        {
          q: 'How do I create an account?',
          a: 'You can create an account by clicking "Account" at the top of the page and selecting "Register". You\'ll need to provide your email address and create a password.'
        }
      ]
    }
  ];

  const toggleItem = (categoryIndex, questionIndex) => {
    const itemId = `${categoryIndex}-${questionIndex}`;
    setOpenItems(prev =>
      prev.includes(itemId)
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="container">
          <h1 className="faq-hero-title">Frequently Asked Questions</h1>
          <p className="faq-hero-description">
            Find answers to common questions about ordering, shipping, returns, and more.
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content">
        <div className="container">
          <div className="faq-grid">
            {faqCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="faq-category">
                <h2 className="category-title">{category.category}</h2>
                <div className="faq-items">
                  {category.questions.map((item, questionIndex) => {
                    const itemId = `${categoryIndex}-${questionIndex}`;
                    const isOpen = openItems.includes(itemId);
                    
                    return (
                      <div key={questionIndex} className="faq-item">
                        <button
                          className="faq-question"
                          onClick={() => toggleItem(categoryIndex, questionIndex)}
                        >
                          <span>{item.q}</span>
                          {isOpen ? <FiChevronUp /> : <FiChevronDown />}
                        </button>
                        <div className={`faq-answer ${isOpen ? 'open' : ''}`}>
                          <p>{item.a}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Still Need Help */}
      <section className="faq-help-section">
        <div className="container">
          <div className="help-box">
            <h2>Still Need Help?</h2>
            <p>If you couldn't find the answer you were looking for, our customer service team is here to assist you.</p>
            <div className="help-buttons">
              <a href="/contact" className="help-btn primary">CONTACT US</a>
              <a href="/track-order" className="help-btn secondary">TRACK ORDER</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;